import Cookie from 'js-cookie';

window.close_dostavka = () => {
    $('.info_block').hide();
    $('#otstup').hide();

    Cookie.set('tomorrow', 'off', {expires: 1, path: '/', secure: false});
};
